"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var common_1 = require("@scuf/common");
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genClasses = function () {
            var _a = _this.props, className = _a.className, disabled = _a.disabled;
            var classes = 'header-bar-item';
            if (className) {
                classes += ' ' + className;
            }
            if (disabled) {
                classes += ' disabled';
            }
            return classes;
        };
        _this.onClickWrap = function () {
            var _a = _this.props, onClick = _a.onClick, disabled = _a.disabled;
            return (onClick && !disabled) && onClick();
        };
        return _this;
    }
    Item.prototype.render = function () {
        var _a = this.props, content = _a.content, icon = _a.icon, iconRoot = _a.iconRoot, iconSize = _a.iconSize, className = _a.className, onClick = _a.onClick, disabled = _a.disabled, rest = __rest(_a, ["content", "icon", "iconRoot", "iconSize", "className", "onClick", "disabled"]);
        return (React.createElement("div", __assign({ className: this.genClasses(), onClick: this.onClickWrap }, rest),
            icon && common_1.genIcon(icon, { size: iconSize, root: iconRoot, className: 'btn-icon' }),
            content));
    };
    Item.defaultProps = {
        iconRoot: 'common'
    };
    return Item;
}(react_1.Component));
exports.default = Item;
//# sourceMappingURL=Item.js.map